// components/notifications/NotificationDetailModalWeb.jsx
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { IoClose } from 'react-icons/io5';
import cls from './NotificationDetailModal.module.css';
import NotificationService from '../../Services/system-notification.service';

const NotificationDetailModal = ({
    notification,
    onClose,
    markLocalRead,
    userId,
    userType,
    t = (x) => x,
    dir
}) => {
    const [imgOpen, setImgOpen] = useState(false);

    /* mark read on first render --------------------------------------- */
    useEffect(() => {
        if (!notification || notification.isRead) return;

        (async () => {
            try {
                await NotificationService.user.markRead(notification.id, {
                    userId: userId,
                    userType: parseInt(userType),
                });
                markLocalRead(notification.id);
            } catch (e) {
                console.error('mark read failed', e.message);
            }
        })();
    }, [notification, userId, userType, markLocalRead]);
    if (!notification) return null;

    return createPortal(
        <>
            <div className={cls.backdrop} onClick={onClose} />
            <article className={cls.modal} role="dialog" aria-modal="true" dir={dir}>
                <header className={cls.header} >
                    <h3>{notification.title}</h3>
                    <button onClick={onClose} className={cls.close}>
                        <IoClose size={26} />
                    </button>
                </header>

                <section className={cls.body} >
                    {notification.imageUrl && (
                        <img
                            src={notification.imageUrl}
                            alt=""
                            className={cls.hero}
                            onClick={() => setImgOpen(true)}
                        />
                    )}

                    <p className={cls.text}>{notification.body}</p>

                    <div className={cls.meta}>
                        <span>
                            {t('Start')}: {new Date(notification.startAt).toLocaleString()}
                        </span>
                        <span>
                            {t('Expires')}: {new Date(notification.expiresAt).toLocaleString()}
                        </span>
                    </div>
                </section>
            </article>

            {/* simple full-bleed lightbox */}
            {imgOpen && (
                <>
                    <div className={cls.backdrop} onClick={() => setImgOpen(false)} />
                    <img
                        src={notification.imageUrl}
                        alt=""
                        className={cls.lightboxImg}
                        onClick={() => setImgOpen(false)}
                    />
                </>
            )}
        </>,
        document.body
    );
};

export default NotificationDetailModal;
